import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { t } from 'i18next';

import { IQuestionEntity } from '../../utils/form';

export const EQUITY_NAMES = {
  TOTAL_STOCKHOLDERS_EQUITY: 'totalStockholdersEquity',
  ADDITIONAL_PAID_IN_CAPITAL: 'additionalPaidInCapital',
  RESERVES: 'reserves',
  ACCUMULATED_OTHER_COMPREHENSIVE_INCOME: 'accumulatedOtherComprehensiveIncome',
  RETAINED_EARNINGS: 'retainedEarnings',
} as const;

export const omitFieldsForTotalEquitySum = [];

export const useGetEquityQuestionList = () => {
  const { t, i18n } = useTranslation();
  return useMemo(() => {
    const equityQuestionList: IQuestionEntity[] = [
      {
        question: t('financialPlan.openingBalanceSheets.initialEquity.equityQuestions.totalStockholdersEquity'),
        name: EQUITY_NAMES.TOTAL_STOCKHOLDERS_EQUITY,
        adornmentType: 'currency',
      },
      {
        question: t('financialPlan.openingBalanceSheets.initialEquity.equityQuestions.additionalPaidInCapital'),
        name: EQUITY_NAMES.ADDITIONAL_PAID_IN_CAPITAL,
        adornmentType: 'currency',
      },
      {
        question: t('financialPlan.openingBalanceSheets.initialEquity.equityQuestions.reserves'),
        name: EQUITY_NAMES.RESERVES,
        adornmentType: 'currency',
      },
      {
        question: t(
          'financialPlan.openingBalanceSheets.initialEquity.equityQuestions.accumulatedOtherComprehensiveIncome',
        ),
        name: EQUITY_NAMES.ACCUMULATED_OTHER_COMPREHENSIVE_INCOME,
        adornmentType: 'currency',
      },
      {
        question: t('financialPlan.openingBalanceSheets.initialEquity.equityQuestions.retainedEarnings'),
        name: EQUITY_NAMES.RETAINED_EARNINGS,
        adornmentType: 'currency',
      },
    ];
    return equityQuestionList;
  }, [t, i18n]);
};

export interface IInitialEquityValuesType {
  [EQUITY_NAMES.TOTAL_STOCKHOLDERS_EQUITY]: string;
  [EQUITY_NAMES.ADDITIONAL_PAID_IN_CAPITAL]: string;
  [EQUITY_NAMES.RESERVES]: string;
  [EQUITY_NAMES.ACCUMULATED_OTHER_COMPREHENSIVE_INCOME]: string;
  [EQUITY_NAMES.RETAINED_EARNINGS]: string;
}

export const initialEquityInitialValues = {
  [EQUITY_NAMES.TOTAL_STOCKHOLDERS_EQUITY]: '',
  [EQUITY_NAMES.ADDITIONAL_PAID_IN_CAPITAL]: '',
  [EQUITY_NAMES.RESERVES]: '',
  [EQUITY_NAMES.ACCUMULATED_OTHER_COMPREHENSIVE_INCOME]: '',
  [EQUITY_NAMES.RETAINED_EARNINGS]: '',
};
